import { render, staticRenderFns } from "./ClientesPage.vue?vue&type=template&id=fdca190e&"
import script from "./ClientesPage.vue?vue&type=script&lang=js&"
export * from "./ClientesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports